// libraries
import React, { useId } from 'react'
import clsx from 'clsx'
import { useFormContext, RegisterOptions } from 'react-hook-form'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils'

// svg
import { Check } from '/react4xp/components/Svg/Ux/Ux'

interface RadioProps {
    id?: string
    name: string
    value: string
    required?: boolean
    disabled?: boolean
    children?: React.ReactNode
    className?: string
    errorMessages?: {
        required?: string
    }
    helperText?: string
}

export default function Radio({
    id,
    name,
    value,
    required,
    disabled,
    children,
    errorMessages,
    className,
    helperText
}: RadioProps) {

    const formContext = useFormContext()
    const register = formContext ? formContext.register : () => ({})
    const errors = formContext ? formContext.formState.errors : {}

    let validations: RegisterOptions = {}

    if (required) {
        validations.required = errorMessages?.required
    }

    const showHelperText = isNonWhitespaceString(helperText)
    const optionId = id || `${name}-${value}`.replace(/\s+/g, '-')
    const instanceId = useId()
    const helperTextId = `${instanceId}-helper-text`

    return (
        <div className={clsx(
            'form-line',
            className,
            errors && errors[name] && 'form-line--error'
        )}>

            <label className={clsx('form-line__checkbox-wrapper')}>

                <input
                    id={optionId}
                    type='radio'
                    value={value}
                    disabled={disabled || false}
                    {...(register ? register(name || '', validations) : {})}
                    aria-describedby={showHelperText ? helperTextId : undefined}
                />

                <span className='form-line__checkbox-wrapper__checkbox'>
                    <Check />
                </span>

                <span className='form-line__checkbox-wrapper__text'>

                    <span className='text-md checkbox-text'>
                        {children}
                    </span>

                </span>

            </label>

            {showHelperText && (
                <div
                    id={helperTextId}
                    className='form-line__help-text form-line__help-text--checkbox text-sm'
                    dangerouslySetInnerHTML={{ __html: helperText }}
                    suppressHydrationWarning
                />
            )}

        </div>
    )
}